import Default from "./Default";
import Scrolling from "./Scrolling";

/**
 * @typedef {import("@prismicio/client").Content.BrandBannerSlice} BrandBannerSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<BrandBannerSlice>} BrandBannerProps
 * @param {BrandBannerProps}
 */
const BrandBanner = ({ slice: { items, variation } }) => {
	switch (variation) {
		case "default":
			return <Default items={items} />;
		case "scrolling":
			return <Scrolling items={items} />;
		default:
			return null;
	}
};

export default BrandBanner;
